export default __webpack_public_path__ + "static/Row 2.3_Finlandway-392b800e76df863356b6c47599194677.jpg";